/* Man Up — reusable fade-up reveals (brief Section 12).
   Any element with class `brand-reveal` fades/rises in when scrolled into view.
   Honours prefers-reduced-motion and degrades gracefully without IO. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealNow(el) {
    el.classList.add('is-revealed');
  }

  var observer = null;
  if (!reduceMotion && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealNow(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('.brand-reveal:not(.is-revealed)');
    els.forEach(function (el) {
      if (observer) {
        observer.observe(el);
      } else {
        revealNow(el); // reduced motion or no IO support
      }
    });
  }

  if (document.readyState !== 'loading') {
    scan(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  }

  // Re-scan when sections re-render in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
